import { render, staticRenderFns } from "./ClockDataGrid.vue?vue&type=template&id=38b27a12"
import script from "./ClockDataGrid.vue?vue&type=script&lang=js"
export * from "./ClockDataGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports